module.exports = __webpack_public_path__ + "resources/img/img_seculetter_email_cloud_security_jp.b8600784b8e342b6d71989ddca74f366.png";